module.exports = __webpack_public_path__ + "img/lec1.d076dd10.png";